import {
	isPlainObject,
	trim
} from "lodash";

import { isSupportedOrNullish } from "./isSupportedOrNullish";

function stripDollarPrefixedProperties(value) {
	if(Array.isArray(value)) {
		return value.map(stripDollarPrefixedProperties);
	}

	if(isPlainObject(value)) {
		return Object.entries(value).reduce((nextValue, [key, childValue]) => {
			if(key.startsWith("$")) {
				return nextValue;
			}

			nextValue[key] = stripDollarPrefixedProperties(childValue);
			return nextValue;
		}, {});
	}

	return value;
}

export function buildEntitySavePayload(entity, entityType) {
	const payload = {
		...entity,
		Code: trim(entity.Code)
	};

	if(payload.TimeZone && payload.TimeZone?.Code === "") {
		payload.TimeZone = null;
	}

	payload.ExternalKey = payload.ExternalKey?.trim();
	if(payload.ExternalKey === "" || payload.ExternalKey === null) {
		delete payload.ExternalKey;
	}

	if(entityType.IsNameDefaultedToCodeWhenNoContact === true && payload.Contact === undefined) {
		payload.Name = payload.Code;
	}

	if(payload.Entities) {
		delete payload.Entities;
	}
	if(payload.Type) {
		delete payload.Type;
	}
	if(payload.friendlies) {
		delete payload.friendlies;
	}
	if((payload.TimeZone && payload.TimeZone.Code === "") || !isSupportedOrNullish(entityType.TimeZone)) {
		delete payload.TimeZone;
	}

	const apiPayload = stripDollarPrefixedProperties(payload);

	return apiPayload;
}

export function mergeSavedEntity(existingEntity, savedEntity) {
	return {
		...existingEntity,
		...(savedEntity ?? {}),
		Type: savedEntity?.Type ?? existingEntity?.Type
	};
}